export default __webpack_public_path__ + "assets/images/34a2a6a5c634dcd49632c37152b255d1.png";